module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown messages-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown notifications-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.notifications)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.notifications)) + " notification(s)")]), _vm._v(" "), (_vm.userInfo.notifications.length > 0) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown tasks-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs user-name"
  }, [_vm._v(_vm._s(_vm.demo.displayName))]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Layer_1",
      "enable-background": "new 0 0 48 48",
      "viewBox": "0 0 48 48",
      "width": "33px",
      "height": "33px",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace",
      "xml:space": "preserve",
      "version": "1.1"
    }
  }, [_c('g', [_c('g', [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "24",
      "cy": "18.796",
      "r": "5.084"
    }
  }), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M 30.943 25.688 H 17.056 c -0.904 0 -1.638 0.733 -1.638 1.638 v 10.337 c 2.501 1.554 5.443 2.467 8.605 2.467 c 3.142 0 6.066 -0.902 8.559 -2.439 V 27.326 C 32.582 26.422 31.848 25.688 30.943 25.688 Z"
    }
  })]), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M 24 0 C 10.745 0 0 10.745 0 24 s 10.745 24 24 24 s 24 -10.745 24 -24 S 37.255 0 24 0 Z M 24.029 43.844 c -11.023 0 -19.959 -8.936 -19.959 -19.959 S 13.006 3.926 24.029 3.926 s 19.959 8.936 19.959 19.959 S 35.052 43.844 24.029 43.844 Z"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu usermenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Logoff")])])])])])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n        "), _c('a', {
    attrs: {
      "href": "https://www.vizeum.com/",
      "target": "blank"
    }
  }, [_vm._v("vizeum")]), _vm._v(".")]), _vm._v(" All rights reserved.\n    ")]), _vm._v(" "), _c('simplert', {
    ref: "confirmbox",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/logo.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_vm._v("\n                          Support Team\n                          "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 5 mins")])]), _vm._v(" "), _c('p', [_vm._v("Why not consider this a test message?")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" 5 new members joined today\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n                          Design some buttons\n                          "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c98a2d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 313
// module chunks = 1